import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Shield({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'18px'} height={'22px'} viewBox={'0 0 18 22'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-3.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M12.4472136,22.8944272 C12.1656861,23.0351909 11.8343139,23.0351909 11.5527864,22.8944272 C11.2759078,22.7559879 10.811078,22.4986714 10.2200011,22.1292483 C9.2398841,21.5166752 8.25994003,20.8062158 7.34149539,20.0025767 C4.64575967,17.6438079 3,14.9694485 3,12 L3,5 C3,4.58315544 3.25857283,4.21003472 3.64887656,4.06367082 L11.6488766,1.06367082 C11.8752617,0.978776393 12.1247383,0.978776393 12.3511234,1.06367082 L20.3511234,4.06367082 C20.7414272,4.21003472 21,4.58315544 21,5 L21,12 C21,14.9694485 19.3542403,17.6438079 16.6585046,20.0025767 C15.74006,20.8062158 14.7601159,21.5166752 13.7799989,22.1292483 C13.188922,22.4986714 12.7240922,22.7559879 12.4472136,22.8944272 Z M12.7200011,20.4332517 C13.6148841,19.8739498 14.50994,19.2250342 15.3414954,18.4974233 C17.6457597,16.4811921 19,14.2805515 19,12 L19,5.69300047 L12,3.06800047 L5,5.69300047 L5,12 C5,14.2805515 6.35424033,16.4811921 8.65850461,18.4974233 C9.49005997,19.2250342 10.3851159,19.8739498 11.2799989,20.4332517 C11.5371291,20.5939581 11.7785991,20.7373457 12,20.8627787 C12.2214009,20.7373457 12.4628709,20.5939581 12.7200011,20.4332517 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Shield.propTypes = {
  className: PropTypes.string,
}
